import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import ResponsiveImage from "components/ResponsiveImage";

export const CardOverlay = styled("div")({
  position: "absolute",
  zIndex: 2,
  left: 0,
  top: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(37, 45, 95, 0.7)",
  visibility: "hidden",
  display: "flex",
  transform: "visibility 0.1s ease-in",
  flexDirection: "column",
});

export const Card = styled("div", {
  shouldForwardProp: (prop) => prop !== "aspectRatio",
})(({ theme, aspectRatio }) => ({
  position: "relative",
  zIndex: 0,
  height: "auto",
  aspectRatio,
  backgroundColor: theme.palette.placeholder,
  [`&:hover ${CardOverlay}`]: {
    visibility: "visible",
  },
  [`&:active ${CardOverlay}`]: {
    visibility: "visible",
  },
  "& .lazyload-wrapper": {
    display: "inline",
  },
}));

export const CardImg = styled(ResponsiveImage)({
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
  position: "relative",
  left: 0,
  top: 0,
  zIndex: 1,
});

export const NameOverlay = styled("div", {
  shouldForwardProp: (prop) => prop !== "isMasonryGrid",
})(({ theme, isMasonryGrid }) => ({
  position: "absolute",
  zIndex: 2,
  left: 0,
  bottom: 0,
  height: "auto",
  width: "100%",
  backgroundColor: "rgba(18, 36, 56, 0.7)",
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  ...(isMasonryGrid && {
    height: 20,
    [theme.breakpoints.up("tablet")]: {
      height: 30,
    },
  }),
}));

export const Name = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "isMasonryGrid",
})(({ theme, isMasonryGrid }) => ({
  color: theme.palette.common.white,
  opacity: 0.7,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  padding: "5px 10px",
  [theme.breakpoints.up("mobile")]: {
    padding: "0 10px",
    fontSize: theme.typography.small.fontSize,
  },
  [theme.breakpoints.up("tablet")]: {
    fontSize: theme.typography.large.fontSize,
  },
  ...(isMasonryGrid && {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    padding: 0,
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.up("tablet")]: {
      fontSize: theme.typography.regular.fontSize,
    },
  }),
}));
